// extracted by mini-css-extract-plugin
module.exports = {"form":"board_search_form__Lx2Yy","search":"board_search_search__18iQ9","btn":"board_search_btn__31S8P"};